<template>
  <svg :viewBox="`0 0 ${W} ${H}`" :style="{height: H + 'px', direction: 'ltr'}">
    <g v-for="g in [0, 25, 50, 75, 100]" :key="'g' + g">
      <line :x1="mS" :y1="Y(g)" :x2="W - 10" :y2="Y(g)" stroke="var(--sd-line-2)" stroke-width="1" />
      <text :x="mS - 6" :y="Y(g) + 3.5" class="ax" text-anchor="end">{{ pctS(g) }}</text>
    </g>
    <g v-for="(g, gi) in groups" :key="g.label">
      <template v-for="(k, ki) in keys">
        <rect v-if="g.vals[k] != null" :key="k" v-tip="`<b>${esc(g.label)}</b> · ${k}<br>${pctHtml(g.vals[k])}`" :x="x0(gi) + ki * (bw + 4)" :y="Y(g.vals[k])" :width="bw" :height="H - mB - Y(g.vals[k])" rx="4"
          :fill="g.color" :opacity="(0.35 + 0.65 * ki / Math.max(1, keys.length - 1)).toFixed(2)" />
        <text v-if="g.vals[k] != null" :key="'l' + k" :x="x0(gi) + ki * (bw + 4) + bw / 2" :y="Y(g.vals[k]) - 5" text-anchor="middle" class="ax" font-size="10">{{ pctS(g.vals[k]) }}</text>
      </template>
      <text :x="mS + gi * gw + gw / 2" :y="H - 10" text-anchor="middle" class="gl">{{ g.label }}</text>
    </g>
  </svg>
</template>
<script>
/* Percent-scale grouped bars: groups=[{label,color,vals:{[key]:pct}}], one bar per key with an opacity ramp. */
import { pctS, pctHtml, esc } from '../../lib/format.js'
export default {
  name: 'SdGroupedBars',
  props: { groups: { type: Array, default: () => [] }, keys: { type: Array, default: () => [] } },
  data: () => ({ W: 520, H: 200, mS: 40, mT: 22, mB: 34 }),
  computed: {
    gw() { return (this.W - this.mS - 20) / Math.max(1, this.groups.length) },
    bw() { return Math.min(26, (this.gw - 20) / Math.max(1, this.keys.length)) },
  },
  methods: {
    pctS, pctHtml, esc,
    Y(v) { return this.mT + (1 - v / 100) * (this.H - this.mT - this.mB) },
    x0(gi) { return this.mS + gi * this.gw + (this.gw - this.bw * this.keys.length - 4 * (this.keys.length - 1)) / 2 },
  },
}
</script>
